import { useNavigate } from 'react-router-dom';
import { logout, setExpirationModal } from '../redux/actions/authentication';
import { axiosAuth, axiosNoAuth } from './axiosInstances';

export function axiosAuthMiddleware({ dispatch, getState, navigate }) {
  // const navigate = useNavigate()
  return (next) => (action) => {
    axiosAuth.interceptors.request.use(
      function (config) {
        const id = getState()?.profileDetails?.id;
        config.headers.Authorization = `Bearer ${getState()?.authentication?.user_token
          }`;
        config.params = {
          ...config.params,
          user_id: id ? id : 0,
        };
        
        // Add URL logging and request_url parameter
        console.log("config", config?.url)
        
        // Add URL as a parameter to all requests
        if (config?.url) {
            // For GET requests, add URL as query parameter
            if (config.method === 'get') {
                config.params = {
                    ...config.params,
                    request_url: `Webapp:${config.url}`
                };
            } 
            // For POST/PUT/PATCH requests, add URL to request body
            else if (['post', 'put', 'patch'].includes(config.method)) {
                if (config.data) {
                    // If data is an object, add URL to it
                    if (typeof config.data === 'object' && !Array.isArray(config.data)) {
                        config.data.request_url = `Webapp:${config.url}`;
                    } else {
                        // If data is not an object, wrap it
                        config.data = {
                            ...config.data,
                            request_url: `Webapp:${config.url}`
                        };
                    }
                } else {
                    // If no data exists, create it
                    config.data = {
                        request_url: `Webapp:${config.url}`
                    };
                }
            }
        }
        
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axiosAuth.interceptors.response.use(
      (response) => {
        return response
      },
      async function (error) {

        const id = getState()?.profileDetails?.id;
        if (error?.response?.status == 401 && id!==0) {
          await dispatch(logout())
          await dispatch(setExpirationModal(true))
        }

        return Promise.reject(error)
      }
    );

    axiosNoAuth.interceptors.request.use(
      function (config) {
        const id = getState().profileDetails?.id;
        config.params = {
          ...config.params,
          user_id: id ? id : 0,
        };
        
        // Add URL logging and request_url parameter
        console.log("config", config?.url)
        
        // Add URL as a parameter to all requests
        if (config?.url) {
            // For GET requests, add URL as query parameter
            if (config.method === 'get') {
                config.params = {
                    ...config.params,
                    request_url: `Webapp:${config.url}`
                };
            } 
            // For POST/PUT/PATCH requests, add URL to request body
            else if (['post', 'put', 'patch'].includes(config.method)) {
                if (config.data) {
                    // If data is an object, add URL to it
                    if (typeof config.data === 'object' && !Array.isArray(config.data)) {
                        config.data.request_url = `Webapp:${config.url}`;
                    } else {
                        // If data is not an object, wrap it
                        config.data = {
                            ...config.data,
                            request_url: `Webapp:${config.url}`
                        };
                    }
                } else {
                    // If no data exists, create it
                    config.data = {
                        request_url: `Webapp:${config.url}`
                    };
                }
            }
        }
        
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
    next(action);
  };
}
